import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderToolbarComponent } from './header-toolbar.component';
import {InfraModule} from 'ac-infra';
import {UserMenuModule} from '../user-menu/user-menu.module';



@NgModule({
    declarations: [HeaderToolbarComponent],
    exports: [
        HeaderToolbarComponent
    ],
  imports: [
    CommonModule,
    InfraModule,
    UserMenuModule
  ]
})
export class HeaderToolbarModule { }
